function loadBuildValidatorReducer(currentState = false, action){
    switch (action.type) {
        case 'IS_VALIDATED':
            return action.payload;
        default:
            break;
    }
    return currentState;
}

export default loadBuildValidatorReducer;